import { getGlobalConfig } from '@core/globalConfig'
import { isTruthy } from '@core/helpers/boolean'

/**
 * Returns true when the `cookies_ephemeral` global config flag is set.
 *
 * Effects:
 * - All `localStorage` reads/writes are transparently redirected to
 *   `window.sessionStorage` (data dies when the tab is closed).
 * - Cookie writes via `setCookie` and the consent-restore snapshot (`fw_cc`)
 *   use `document.cookie` without an `expires` attribute, making them
 *   session cookies that the browser discards at session end.
 */
export function isCookiesEphemeral(): boolean {
  return isTruthy(getGlobalConfig().cookies_ephemeral)
}
